import { CommonEditContext } from "./common-data.model";

export const DefaultSupervisorControlPanel = {
  edit: {
    editForm: {
      model: {} as SupervisorControlPanelEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<SupervisorControlPanelEditCriteria>,
}

export interface SupervisorControlPanelEditCriteria {
  hackApexID: string;
  invokeCommands: string[];
}
